var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDefaultPatient(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 94.668,
    height: 119.218,
    viewBox: "0 0 94.668 119.218",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_332",
    "data-name": "Group 332",
    transform: "translate(-505.159 -92.957)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_298",
    "data-name": "Path 298",
    d: "M544.616,108.918l-3.682,6.351a10.091,10.091,0,0,1-5.448,4.483l-13.4,4.62a15.986,15.986,0,0,0-1.814.562l-.212.08a17.452,17.452,0,0,0-11.121,16.405l-2.288,19.539",
    transform: "translate(0 51.042)",
    fill: "none",
    stroke: "#6c5b7b",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_299",
    "data-name": "Path 299",
    d: "M518.787,108.918l3.687,6.351a10.092,10.092,0,0,0,5.448,4.483l13.4,4.62a15.971,15.971,0,0,1,1.814.562l.212.08a17.452,17.452,0,0,1,11.121,16.405l2.288,19.539",
    transform: "translate(41.579 51.042)",
    fill: "none",
    stroke: "#6c5b7b",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_300",
    "data-name": "Path 300",
    d: "M512.255,101.705c.212,5.222,2,17.733,7.408,26.376a15.779,15.779,0,0,0,27.212,0c4.257-6.545,6.5-17.751,6.5-25.195",
    transform: "translate(19.204 26.334)",
    fill: "none",
    stroke: "#6c5b7b",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_301",
    "data-name": "Path 301",
    d: "M549.083,101.5a21.471,21.471,0,0,0-31.669.828,22.439,22.439,0,0,0-5.01,18.9l.668,3.669a24.126,24.126,0,0,0,13.489-14.781",
    transform: "translate(18.387 3.143)",
    fill: "none",
    stroke: "#6c5b7b",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_302",
    "data-name": "Path 302",
    d: "M514.985,99.158c8.479,10.086,17.33,4.129,29.04,12.453",
    transform: "translate(28.555 17.609)",
    fill: "none",
    stroke: "#6c5b7b",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_303",
    "data-name": "Path 303",
    d: "M513.165,111.366l16.571,13.811,17.445-13.811",
    transform: "translate(22.32 59.429)",
    fill: "none",
    stroke: "#6c5b7b",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_304",
    "data-name": "Path 304",
    d: "M536.591,94.017,521.006,109.6h15.585L523.2,122.994",
    transform: "translate(49.181 0)",
    fill: "none",
    stroke: "#6c5b7b",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultPatient);
export default __webpack_public_path__ + "static/media/defaultPatient.043f67b2ccaccabb5d0e5044cb3ab809.svg";
export { ForwardRef as ReactComponent };